import { createAction } from 'redux-actions';

import { CREATE_INVENTORY } from './constants';

export const createInventory = createAction(CREATE_INVENTORY.REQUEST);
